import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip,
  orderWithRoundTripOneBoundScheduleChange,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const roundTripOneBoundScheduleChangeMock: MockMap = {
  retrieveOrder: [createMockData(orderWithRoundTripOneBoundScheduleChange, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip, [], [orderNotEligibleForRefundWarning])]
};
